import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import HeroSection from './components/HeroSection';
import OurPhilosophy from './components/OurPhilosophy';
import PartnersSection from '../Home/components/PartnersSection';
import { BLACK } from '@plootus/common';
import Canonical from '../../../Utils/Canonical/Canonical';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
}));

const Philosophy = () => {
  const classes = useStyles();

  return (
  <>
    <HubNav />
    <PageHeaders
      title="Our Philosophy - Plootus"
      description="Learn about Plootus' approach to retirement planning and financial wellness. Our philosophy centers on transparency, education, and empowering individuals."
      keywords="Plootus philosophy, retirement planning approach, financial wellness, transparent investing, financial education"
      canonicalUrl="https://www.plootus.com/philosophy"
    />
    <Canonical />
    <main className={classes.root}>
      <HeroSection />
      <OurPhilosophy />
      <PartnersSection titleColor={BLACK} titleFontSize="35px" subtitleFontSize="17px" />
    </main>
    </>
  );
};

export default Philosophy;
